import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./main.css";

import VueCroppie from "vue-croppie";
import "croppie/croppie.css"; // import the croppie css manually

Vue.use(VueCroppie);

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import "./custom.scss";

import FormBuilder from "../../Breeze.FormBuilder.Frontend/plugins/formBuilder";

import Controls from "./plugins/controls";

import Filters from "./plugins/filters";

import Mixins from "./plugins/mixins";

import Directives from "./plugins/directives";

import DropdownMixin from "./plugins/dropdownMixin";

import ToggleMixin from "./plugins/toggleMixin";

import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import DialogConfirm from "./components/controls/DialogConfirm.vue";
import DialogConfirmUnsavedChanges from "./components/controls/DialogConfirmUnsavedChanges.vue";
import DialogConfirmDelete from "./components/controls/DialogConfirmDelete.vue";
import DialogMultipleActions from "./components/controls/DialogMultipleActions.vue";
import DialogUnlockDocument from "./components/controls/DialogUnlockDocument.vue";
import DialogRadioButtons from "./components/controls/DialogRadioButtons.vue";
import DialogInfo from "./components/controls/DialogInfo.vue";
import DialogPaymentResult from "./components/controls/DialogPaymentResult.vue";
import DialogErrorModal from "./components/controls/DialogErrorModal.vue";

import VueDragDrop from "vue-drag-drop";

import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";

import VueSignaturePad from "vue-signature-pad";

import { initializeToken } from "./helpers/session";

import coreServer from "./server/core";

import VueHtmlToPaper from "vue-html-to-paper";

import VueToggles from "vue-toggles";

import VueMask from "v-mask";

import "fontawesome-4.7";

import "./assets/fa6/css/all.css";

import VCalendar from "v-calendar";

import InputFacade from "vue-input-facade";

import VueCodemirror from "vue-codemirror";

import "codemirror/lib/codemirror.css";

import frag from "vue-frag";

import Chart from "chart.js/auto";
import ShadowLineChart from "./third_party/chartjs/ShadowLineChart";

import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import sanitizeHtml from "sanitize-html";
import sanitizeOptions from "./config/sanitize";

Chart.register(ShadowLineChart);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.use(FormBuilder);

Vue.use(Controls);

Vue.use(Filters);

Vue.use(Directives);

Vue.use(Mixins);

Vue.use(DropdownMixin);

Vue.use(ToggleMixin);

Vue.use(VuejsDialog);

Vue.dialog.registerComponent("confirm", DialogConfirm);

Vue.dialog.registerComponent(
  "confirm-unsaved-changes",
  DialogConfirmUnsavedChanges
);

Vue.dialog.registerComponent("confirm-delete", DialogConfirmDelete);

Vue.dialog.registerComponent("multiple-actions", DialogMultipleActions);

Vue.dialog.registerComponent("unlock-document", DialogUnlockDocument);

Vue.dialog.registerComponent("radio-buttons", DialogRadioButtons);

Vue.dialog.registerComponent("info", DialogInfo);

Vue.dialog.registerComponent("error", DialogErrorModal);
Vue.dialog.registerComponent("payment-result", DialogPaymentResult);

Vue.use(VueDragDrop);

Vue.component("v-select", vSelect);

Vue.use(VueSignaturePad);

Vue.config.productionTip = false;

const options = {
  name: "_new",
  specs: ["titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "./main.css",
    "./third_party/grid/grid.stockholm.css"
  ]
};

Vue.use(VueHtmlToPaper, options);

Vue.component("vue-toggles", VueToggles);

Vue.use(VueMask);

Vue.use(VCalendar);

Vue.use(InputFacade);

Vue.use(VueCodemirror, {
  /* options: { theme: 'base16-dark', ... } */
});

Vue.directive("frag", frag);

Vue.use(VueTelInput, options);

Vue.prototype.$sanitize = function(html) {
  return sanitizeHtml(html, sanitizeOptions);
};

initializeToken().then(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
    created() {
      coreServer.setupInterceptors(store);
      store.dispatch(`layout/fetchInitialData`);
    }
  }).$mount("#app");
});
